// ─── for_env Row Visibility ──────────────────────────────────────────────────
//
// The live-call admin tables (prompts, models, deck groups/slides) share one DB
// between the TEST and PRODUCTION deployments; each row carries `for_env` saying
// where it is visible. Rows are created stamped with the authoring deployment's
// env, and the admin moves them anywhere via the env selector (PATCH `for_env`).
// Values mirror the backend (live-call-db.constants.ts / Python ForEnvMixin).

export const FOR_ENV_PRODUCTION = 1;
export const FOR_ENV_TEST = 2;
export const FOR_ENV_BOTH = 3;

/** One choice of the env selector. */
export interface ForEnvOption {
  value: number;
  label: string;
}

/** Selector choices, in the order an authoring flow moves through them. */
export const FOR_ENV_OPTIONS: ForEnvOption[] = [
  { value: FOR_ENV_TEST, label: 'Test' },
  { value: FOR_ENV_PRODUCTION, label: 'Production' },
  { value: FOR_ENV_BOTH, label: 'Test + Production' },
];

/** Human label for an env badge or confirm dialog. */
export function forEnvLabel(forEnv: number | undefined | null): string {
  if (forEnv === FOR_ENV_PRODUCTION) return 'Production';
  if (forEnv === FOR_ENV_TEST) return 'Test';
  if (forEnv === FOR_ENV_BOTH) return 'Test + Production';
  return '—';
}

/** Tailwind classes for an env badge/selector, matching the deck-admin chip style. */
export function forEnvBadgeClass(forEnv: number | undefined | null): string {
  if (forEnv === FOR_ENV_PRODUCTION) {
    return 'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-400';
  }
  if (forEnv === FOR_ENV_TEST) {
    return 'bg-amber-50 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400';
  }
  if (forEnv === FOR_ENV_BOTH) {
    return 'bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400';
  }
  return 'bg-slate-100 dark:bg-slate-700/50 text-slate-500 dark:text-slate-400';
}

/** True when the target env exposes the row to production live calls. */
export function envIncludesProduction(forEnv: number): boolean {
  return forEnv === FOR_ENV_PRODUCTION || forEnv === FOR_ENV_BOTH;
}
